(function () {
    "use strict";

    angular.module("app").component("habilNotificationBody", {
        templateUrl: "@/notifications/notification-body.html",
        bindings: {
            notification: "<",
            index: "<"
        },
        transclude: true,
        controller: NotificationBodyController
    });

    NotificationBodyController.$inject = ["notificationsService"];
    function NotificationBodyController(notificationsService) {
        const vm = this;

        vm.Open = () => notificationsService.Open(vm.notification);
    }
})();
